import * as types from "../constants/ActionTypes";

const refresh = () => ({ type: types.PREFECTURES_WILL_REFRESH });

const refreshSuccess = data => ({ type: types.PREFECTURES_DID_REFRESH, data });

const refreshFailure = error => ({
  type: types.PREFECTURES_DID_REFRESH_FAILED,
  error
});

export { refresh, refreshSuccess, refreshFailure };
